// Resume will return ok if customer session can be used
// Error Cases:
// 9000: Customer needs to logout, should not continue using the current session
export const SessionService_ResumeLazy = () =>
  import("./service.grpc").then((m) => m.SessionService_Resume);
SessionService_ResumeLazy.method =
  "aysa_api.services.session.SessionService/Resume" as const;
